import { isMobile } from '../helpers/isMobile';
import {
  appendActiveFiltersIndication, hideFiltersWithNoResults, updateProductCount, toggleMobileMenu,
  renderActiveFiltersFromState, resetFiltersDom, showAllProducts, removeActiveFilterFromState,
  resetState, filterProductsDom, filterProductsArray, updateUrlParamsFromState, countProductsByGroups,
  gaUpdateFilterState, gaDatalayerPush
} from './productFilterHelpers';

/**
 * Toggles single filter on/off. When the filter is toggled, the button active/inactive appearance
 * is set, the temp state is updated, filters with no results are hidden, while the number of
 * products that would be displayed if the filters are applied is updated.
 * @param {Event} event Click event
 * @param {Object} classObj Class instance
 */
export function onFilterToggle(event, classObj) {
  const $currentTarget = $(event.currentTarget);
  $currentTarget.toggleClass('product-filter-btn--is-active');
  const id = event.currentTarget.id;
  const isActive = $currentTarget.hasClass('product-filter-btn--is-active');
  const $filterGroup = $currentTarget.parents('.js-product-filter-item');
  const selectOneFilterPerGroup = $filterGroup.attr('data-select-one-filter');
  const $activeFilters = $filterGroup.find('.js-product-filter-item-active');
  const filterGroup = $filterGroup.data('filter-group');
  const name = $currentTarget.data('filter-name');
  const label = $currentTarget.next('.product-filter-accordion-label').text();

  if (isActive) {
    classObj.tempState.activeFilters.push({
      filterGroup,
      label,
      name,
      id
    });
    appendActiveFiltersIndication($activeFilters, label, id);
  } else {
    removeActiveFilterFromState(classObj.tempState, name);
    $activeFilters.find(`.js-product-filter-single-active[data-filter-name="${name.toLowerCase()}"]`).remove();
  }

  classObj.tempState.products = filterProductsArray(classObj.tempState, classObj);
  updateProductCount(classObj.tempState);
  hideFiltersWithNoResults(classObj.tempState, classObj);
  countProductsByGroups();

  if (selectOneFilterPerGroup === 'true') {
    const $otherCheckboxes = $filterGroup.find('.js-product-filter-btn').not($currentTarget);
    $otherCheckboxes.toggleClass('js-single-select-checkbox', isActive);
    isActive ? $otherCheckboxes.prop('disabled', true) : $otherCheckboxes.prop('disabled', false);
  }

  // Google Analytics
  gaUpdateFilterState(label.trim(), filterGroup);

  if (!isMobile()) {
    onFilterApply(classObj);
  }
}

/**
 * Toggle filter item group appearance
 * On mobile screens toggles accordion, on desktop a dropdown.
 * @param {JQuery} $filter
 * @param {Object} classObj - class instance
 */
export function onFilterGroupToggle($filter, classObj) {
  const isOpen = $filter.hasClass('product-filter-item--is-active');
  const isExpanded = $filter.find('.accordion-expanded').length > 0;

  $('.product-filter-item--is-active').removeClass('product-filter-item--is-active');
  $filter.find('.js-product-filter-icon')
    .toggleClass('icon-arrow-down', isOpen)
    .toggleClass('icon-arrow-up', !isOpen);

  $filter.find('.js-product-filter-item-toggle').attr('aria-expanded', isExpanded);

  const closeFilter = event2 => {
    const $clicked = $(event2.target);

    // Turn off event if the filter is applied, or canceled by btn click
    if ($clicked.hasClass('js-product-filter-apply')) {
      $('body').off('click', event3 => closeFilter(event3));
    }
    // if the target of the click isn't the container nor a descendant of the container
    if (!$filter.is(event2.target) && $filter.has(event2.target).length === 0) {
      onFilterItemClose($filter, classObj);
      $('body').off('click', event3 => closeFilter(event3));

      // If clicked on another filter open it
      const $clickedParentFilter = $clicked.parents('.js-product-filter-item');
      if ($clicked.hasClass('.js-product-filter-item') || $clickedParentFilter.length) {
        onFilterGroupToggle($clickedParentFilter, classObj);
      }
    }
  }

  if (!isOpen) {
    $filter.addClass('product-filter-item--is-active');
    if (!isMobile()) {
      $('body').on('click', event2 => closeFilter(event2));
    }
    let $arrow = $filter.find('.arrow');
    if (!$arrow.length) {
      $arrow = $('<div class="arrow"></div>');
      $filter.append($arrow);
    }
    $arrow.css({ left: ($filter.width() / 2) - ($arrow.width() / 2) });
  }
  updateProductCount(classObj.tempState);
}

/**
 * Close filter accordion / dropdown
 * @param {JQuery} $filter
 * @param {Object} classObj - class instance
 */
export function onFilterItemClose($filter, classObj) {
  $filter.removeClass('product-filter-item--is-active')
    .find('.js-product-filter-icon')
      .addClass('icon-arrow-down')
      .removeClass('icon-arrow-up');

  if (!isMobile()) {
    resetState(classObj.tempState, classObj.state);
    renderActiveFiltersFromState(classObj.state);
    hideFiltersWithNoResults(classObj.state, classObj);
  }
}

/**
 * Reset all filters and show all products
 * @param {Object} classObj - class instance
 */
export function onFilterResetAll(classObj) {
  showAllProducts();
  resetFiltersDom(true);
  classObj.state.products = new Set(classObj.allProducts);
  classObj.state.activeFilters = [];

  resetState(classObj.tempState, classObj.state);
  updateProductCount(classObj.state);
  hideFiltersWithNoResults(classObj.state, classObj);
  $('.js-product-filter-no-products-match').addClass('hide');
  $('.js-product-filter').removeClass('product-filter--has-applied-filters');
  updateUrlParamsFromState(classObj);
  countProductsByGroups();
}

/**
 * Close modal window. Cache new filters state. Update filters UI and finally filter products.
 * @param {Object} classObj - Class instance
 */
export function onFilterApply(classObj) {
  toggleMobileMenu(classObj, false);
  resetState(classObj.state, classObj.tempState);
  filterProductsDom(classObj.state);
  renderActiveFiltersFromState(classObj.state);
  $('.js-product-filter').toggleClass('product-filter--has-applied-filters',
    classObj.state.activeFilters.length > 0);
  updateUrlParamsFromState(classObj);
  countProductsByGroups();

  // Google Analytics
  gaDatalayerPush();
}

/**
 * Deactivate applied single filter on x click.
 * @param {Event} event click event
 * @param {Object} classObj - class instance
 */
export function onFilterDeactivate(event, classObj) {
  const $filterRemove = $(event.currentTarget);
  const $filter = $filterRemove.parents('.js-product-filter-applied-item');
  const filterName = $filterRemove.data('filter-name');
  const filterGroupName = $filter.data('filter-group');
  const filterlabel = $(event.currentTarget).siblings('span').text().trim();
  const $filterGroup = $(`.js-product-filter-item[data-filter-group="${filterGroupName}"]`);
  $(`.js-product-filter-btn[data-filter-name="${filterName}"]`).prop('checked', false);

  $filter.remove();
  $filterGroup.find(`[data-filter-name="${filterName}"]`)
    .removeClass('product-filter-btn--is-active');

  if ($filterGroup.find('.product-filter-btn--is-active').length === 0) {
    $filterGroup.removeClass('product-filter-item--is-applied');
  }

  removeActiveFilterFromState(classObj.state, filterName);
  classObj.state.products = filterProductsArray(classObj.state, classObj);
  resetState(classObj.tempState, classObj.state);

  toggleMobileMenu(classObj, false);
  filterProductsDom(classObj.state);
  hideFiltersWithNoResults(classObj.state, classObj);
  if (!classObj.state.activeFilters.length) {
    $('.js-product-filter').removeClass('product-filter--has-applied-filters');
    $('.js-product-filter-nothing-applied').removeClass('hide');
  }
  updateUrlParamsFromState(classObj);
  renderActiveFiltersFromState(classObj.state);
  countProductsByGroups();

  // Google Analytics
  gaUpdateFilterState(filterlabel);
  gaDatalayerPush();
}

/**
 * Close dropdown on desktop if resizing from mobile
 * @param {Object} classObj - class instance
 */
export function onWindowResize(classObj) {
  if (!isMobile()) {
    renderActiveFiltersFromState(classObj.state);
  }
  updateProductCount(classObj.tempState);
}
